import { BaseModel } from '@shared/base/Base.Model';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { IRestModel } from '@shared/interface/IRestModel';

export interface IPathMapPointModel extends IRestModel {
    x: number;
    y: number;
}

export class PathMapPointModel extends BaseModel implements IPathMapPointModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public x: number = null;
    public y: number = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-PathMapPointModel');
    }

    public toRestApiModel(): any {
        return {
        };
    }
}
